import React from "react";
import styled from "styled-components";
import { z } from "zod";
import ContentstackImg from "./ContentstackImg";
import CssCroppedImage from "./CssCroppedImage";
import { FocalPointSchema, ImageAssetSchema, ImageSource, ImageFitSchema, } from "../types";
import { SanityImage } from "../../Media";
export const ImagePropsSchema = z.object({
    image: ImageAssetSchema,
    optimized: z.boolean().optional(),
    crop: z.boolean().optional(),
    fit: ImageFitSchema.optional(),
    loading: z.enum(["lazy", "eager"]).optional(),
    focalPoint: FocalPointSchema.optional(),
    pixelRatio: z.number().optional(),
});
const StylableImage = ({ image, optimized = true, crop, fit, pixelRatio, focalPoint, loading = "lazy", ...imgProps }) => {
    switch (image.type) {
        case ImageSource.CONTENTSTACK:
            return (React.createElement(ContentstackImg, { image: image, optimized, crop, fit, pixelRatio, focalPoint, loading, ...imgProps }));
        case ImageSource.SANITY:
            return (React.createElement(SanityImage, { media: { ...image, type: "image", provider: "sanity" }, optimized, crop, fit, pixelRatio, ...imgProps }));
        case ImageSource.DATADRAGON:
        case ImageSource.YOUTUBE:
        case ImageSource.WEB:
            return React.createElement(CssCroppedImage, { image: image, loading: loading, ...imgProps });
        default: {
            const _ = image;
            throw new Error(`Warning: unknown image type. ${_}`);
        }
    }
};
StylableImage.defaultProps = {
    "data-testid": "image",
};
export const Image = styled(StylableImage) `
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
//# sourceMappingURL=Image.js.map